import React, { useContext } from 'react';
import Forward from '@src/components/wysiwyg_editor/page_content_items/control_panels/Forward';
import Backward from '@src/components/wysiwyg_editor/page_content_items/control_panels/Backward';
import Delete from '@src/components/wysiwyg_editor/page_content_items/control_panels/Delete';
import type { TTextBoxContentItem } from '@src/types/wysiwyg_editor';
import { useDispatch } from 'react-redux';

import ButtonList from '@src/components/wysiwyg_editor/page_content_items/control_panels/ButtonList';
import {
  deletePageContentItem,
  movePageContentItemBackward,
  movePageContentItemForward,
  moveTextContentToCache,
  saveSnapshot
} from '@src/actions/wysiwyg/editor';
import { WysiwygEditorDispatchContext } from '@src/contexts/wysiwyg/editor';
import MoveToDrafts from '../../control_panels/MoveToDrafts';
import useIsLargeScreen from '@src/hooks/useIsLargeScreen';

type TProps = {
  itemData: TTextBoxContentItem;
  beforeMoveToDrafts: () => void;
};

function MainPanel(props: TProps): React.ReactElement {
  const dispatch = useDispatch();
  const { openToolboxTab } = useContext(WysiwygEditorDispatchContext);
  const isLarge = useIsLargeScreen();

  return (
    <ButtonList>
      {isLarge ? (
        <MoveToDrafts
          onClick={() => {
            props.beforeMoveToDrafts();

            // wait one tick after the beforeMoveToDrafts execution
            setTimeout(function () {
              dispatch(saveSnapshot());
              dispatch(moveTextContentToCache(props.itemData));
              openToolboxTab('text');
            }, 0);
          }}
        />
      ) : null}
      <Forward
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(movePageContentItemForward(props.itemData.id));
        }}
      />
      <Backward
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(movePageContentItemBackward(props.itemData.id));
        }}
      />
      <Delete
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(deletePageContentItem(props.itemData.id));
        }}
      />
    </ButtonList>
  );
}

export default MainPanel;
